<template lang="html">
  <div id="about-us-page" data-aos="fade">

    <section class="main-section">
      <div class="placed-backg box-image"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-6 col-text" data-aos="fade-up">
            <h1 class="mb-2 title-s1 f-w-700 c-primary">HISTORIA</h1>

            <!-- <h5 class="subtitle">x</h5> -->
            <p>
              Somos una empresa fundada en el año 2000, que inicio operaciones en el 2001, con un grupo de gente joven y de experiancia en el mercado y los procesos, asi como conocimiento de los equipos y las materias primas, con entusiasmo, una vision de servicio y con la misión puesta en el servicio al cliente.
            </p>

            <p class="mt-3">
              Desde nuestros inicios hemos tenido bien claro nuestras metas y objetivos, dandole prioridadal servico a nuestros clientes actuales, pero preparandos cada dia para atender macados mas exigentes añadiendo a nuestros procesos valores agregados tales como el tratamiento corona, coextrusiones corte y rebobinado.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="vision-section">
      <div class="container oversized-container">
        <div class="box-plans">
          <h2 class="text-center title-2">NOSOTROS</h2>

          <!-- <p class="p-md text-center">
            xx
          </p> -->

          <div class="row row-plans">
            <div class="col-lg-6 col-plan">
              <h6 class="title">Visión</h6>
              <p>
                Ser una empresa líder en el mercado mexicano como proveedor y fabricante de laminas de plastico en el mediano plazo ser referencia en el mercado del plastico y como organizacion ser la empresa que nuestros clientes necesitan para cubrir sus expectativas tener tecnologia acorde con el mercado, y estar siempre atentos a mejorar los procesos.
              </p>
            </div>

            <div class="col-lg-6 col-plan">
              <h6 class="title">Misión</h6>
              <p>
                Proveer las mejores láminas y rollos de plástico, que satisfagan y aún superen las expectativas de nuestros clientes, con un proceso de mejora continua, desarrollando nuestro personal y proveedores con el trabajo en equipo como base de nuestra calidad y servicio, cumpliendo las expectativas de nuestros empleados y accionistas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container values-section">
      <h2 class="text-center title-2">VALORES</h2>

      <div class="row">
        <div class="col-sm-6 col-lg-3 col-value">
          <div class="b-icon">
            <img src="public/images/pages/about-us/icon-1.png">
          </div>

          <h5 class="text">Honestidad</h5>
        </div>

        <div class="col-sm-6 col-lg-3 col-value">
          <div class="b-icon">
            <img src="public/images/pages/about-us/icon-2.png">
          </div>

          <h5 class="text">Innovación</h5>
        </div>

        <div class="col-sm-6 col-lg-3 col-value">
          <div class="b-icon">
            <img src="public/images/pages/about-us/icon-3.png">
          </div>

          <h5 class="text">Valentía</h5>
        </div>

        <div class="col-sm-6 col-lg-3 col-value">
          <div class="b-icon">
            <img src="public/images/pages/about-us/icon-4.png">
          </div>

          <h5 class="text">Compromiso</h5>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
